import { Injectable, Component, ElementRef, ChangeDetectorRef, Input, HostBinding, HostListener, Directive, TemplateRef, Optional, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwButtonModule } from '@aw/ads-components/aw-button';
import { AwAnchoredBottomPanelModule } from '@aw/ads-components/aw-anchored-bottom-panel';
import { AwStepperProgressModule } from '@aw/ads-components/aw-stepper-progress';
import { DualContentService } from '@aw/ads-components/src/services/dual-content';
import { AwMultiColumnContentModule } from '@aw/ads-components/aw-multi-column-content';
import { AwProgressBarModule } from '@aw/ads-components/aw-progress-bar';
import { AwMobileLayoutModule } from '@aw/ads-components/aw-mobile-layout';
import { AwComponent } from '@aw/ads-components/aw-parent';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LAYOUT_TYPES } from '@aw/ads-components/src/enums';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@aw/ads-components/aw-anchored-bottom-panel';

function AwResponsiveLayoutComponent_aw_responsive_layout_type1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "aw-responsive-layout-type1", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("styleClasses", "", ctx_r0.styleClasses, " type1");
    ɵngcc0.ɵɵproperty("elementId", ctx_r0.elementId)("mobileBackgroundUrl", ctx_r0.mobileBackgroundUrl)("desktopBackgroundUrl", ctx_r0.desktopBackgroundUrl)("anchoredBottomPanel", ctx_r0.layoutElements.anchoredBottomPanel)("automationValue", ctx_r0.automationValue)("footer", ctx_r0.layoutElements.footer)("content", ctx_r0.layoutElements.content)("title", ctx_r0.layoutElements.header)("subtitle", ctx_r0.layoutElements.subheader)("pageTitle", ctx_r0.layoutElements.pageTitle)("mobilePageTitle", ctx_r0.layoutElements.mobilePageTitle)("pageTitleLeft", ctx_r0.layoutElements.pageTitleLeft)("mobilePageTitleLeft", ctx_r0.layoutElements.mobilePageTitleLeft)("pageTitleRight", ctx_r0.layoutElements.pageTitleRight)("mobilePageTitleRight", ctx_r0.layoutElements.mobilePageTitleRight)("globalFooter", ctx_r0.layoutElements.globalFooter)("mode", ctx_r0.mode)("floatingDialog", ctx_r0.layoutElements.floatingDialog)("fullWideContentArea", ctx_r0.fullWideContentArea)("sixColumnContent", ctx_r0.sixColumnContent)("progressStepper", ctx_r0.layoutElements.progressStepper)("navigation", ctx_r0.layoutElements.navigation)("fixedHeight", ctx_r0.fixedHeight);
} }
function AwResponsiveLayoutComponent_aw_responsive_layout_type2_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "aw-responsive-layout-type2", 7);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("styleClasses", ctx_r1.styleClasses)("elementId", ctx_r1.elementId)("mobileBackgroundUrl", ctx_r1.mobileBackgroundUrl)("desktopBackgroundUrl", ctx_r1.desktopBackgroundUrl)("mode", ctx_r1.mode)("footer", ctx_r1.layoutElements.footer)("content", ctx_r1.layoutElements.content)("titleImage", ctx_r1.layoutElements.titleImage)("title", ctx_r1.layoutElements.header)("subtitle", ctx_r1.layoutElements.subheader)("topPanel", ctx_r1.layoutElements.topPanel)("globalFooter", ctx_r1.layoutElements.globalFooter)("automationValue", ctx_r1.automationValue)("navigation", ctx_r1.layoutElements.navigation)("fixedHeight", ctx_r1.fixedHeight);
} }
function AwResponsiveLayoutComponent_aw_responsive_layout_type3_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "aw-responsive-layout-type3", 8);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("styleClasses", ctx_r2.styleClasses)("elementId", ctx_r2.elementId)("mobileBackgroundUrl", ctx_r2.mobileBackgroundUrl)("desktopBackgroundUrl", ctx_r2.desktopBackgroundUrl)("anchoredBottomPanel", ctx_r2.layoutElements.anchoredBottomPanel)("stepperLeft", ctx_r2.layoutElements.stepperLeft)("stepperCenter", ctx_r2.layoutElements.stepperCenter)("stepperRight", ctx_r2.layoutElements.stepperRight)("title", ctx_r2.layoutElements.header)("breadcrumbs", ctx_r2.layoutElements.breadcrumbs)("mobileBreadcrumbs", ctx_r2.layoutElements.mobileBreadcrumbs)("content", ctx_r2.layoutElements.content)("globalFooter", ctx_r2.layoutElements.globalFooter)("automationValue", ctx_r2.automationValue)("mode", ctx_r2.mode)("stripBannerGradient", ctx_r2.stripBannerGradient)("navigation", ctx_r2.layoutElements.navigation)("fixedHeight", ctx_r2.fixedHeight);
} }
function AwResponsiveLayoutComponent_aw_responsive_layout_base_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "aw-responsive-layout-base", 9);
    ɵngcc0.ɵɵprojection(1, 0, ["ngProjectAs", "[aw-responsive-layout-header]", 5, ["", "aw-responsive-layout-header", ""]]);
    ɵngcc0.ɵɵprojection(2, 1, ["ngProjectAs", "[aw-responsive-layout-content]", 5, ["", "aw-responsive-layout-content", ""]]);
    ɵngcc0.ɵɵprojection(3, 2, ["ngProjectAs", "[aw-responsive-layout-footer]", 5, ["", "aw-responsive-layout-footer", ""]]);
    ɵngcc0.ɵɵprojection(4, 3, ["ngProjectAs", "[aw-responsive-layout-floating-dialog]", 5, ["", "aw-responsive-layout-floating-dialog", ""]]);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("fullWidth", ctx_r3.fullWidth)("fullscreen", ctx_r3.fullscreen)("fullscreenOnSmall", ctx_r3.fullscreenOnSmall)("styleClasses", ctx_r3.styleClasses)("elementId", ctx_r3.elementId)("mobileBackgroundUrl", ctx_r3.mobileBackgroundUrl)("desktopBackgroundUrl", ctx_r3.desktopBackgroundUrl)("automationValue", ctx_r3.automationValue)("fixedHeight", ctx_r3.fixedHeight);
} }
function AwResponsiveLayoutComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
const _c0 = [[["", "aw-responsive-layout-header", ""]], [["", "aw-responsive-layout-content", ""]], [["", "aw-responsive-layout-footer", ""]], [["", "aw-responsive-layout-floating-dialog", ""]]];
const _c1 = ["[aw-responsive-layout-header]", "[aw-responsive-layout-content]", "[aw-responsive-layout-footer]", "[aw-responsive-layout-floating-dialog]"];
const _c2 = [[["", "aw-responsive-layout-header", ""]], [["", "aw-responsive-layout-content", ""]], [["", "aw-responsive-layout-floating-dialog", ""]], [["", "aw-responsive-layout-footer", ""]]];
const _c3 = function (a0) { return { "background-image": a0 }; };
const _c4 = ["[aw-responsive-layout-header]", "[aw-responsive-layout-content]", "[aw-responsive-layout-floating-dialog]", "[aw-responsive-layout-footer]"];
function AwResponsiveLayoutType1Component_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType1Component_div_0_ng_container_2_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.navigation);
} }
function AwResponsiveLayoutType1Component_div_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_5_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType1Component_div_5_div_3_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.mobilePageTitle || ctx_r15.pageTitle);
} }
function AwResponsiveLayoutType1Component_div_5_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType1Component_div_5_div_4_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(25);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.mobilePageTitleRight || ctx_r16.pageTitleRight || _r11);
} }
function AwResponsiveLayoutType1Component_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType1Component_div_5_ng_container_2_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutType1Component_div_5_div_3_Template, 2, 1, "div", 22);
    ɵngcc0.ɵɵtemplate(4, AwResponsiveLayoutType1Component_div_5_div_4_Template, 2, 1, "div", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r11 = ɵngcc0.ɵɵreference(25);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.mobilePageTitleLeft || ctx_r1.pageTitleLeft || _r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!(ctx_r1.pageTitle || !!ctx_r1.mobilePageTitle) && ctx_r1.mode !== ctx_r1.layoutType.C && ctx_r1.mode !== ctx_r1.layoutType.E);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.mode !== ctx_r1.layoutType.C && ctx_r1.mode !== ctx_r1.layoutType.E);
} }
function AwResponsiveLayoutType1Component_div_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_10_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType1Component_div_10_div_4_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r20.pageTitle);
} }
function AwResponsiveLayoutType1Component_div_10_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_10_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType1Component_div_10_div_5_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(25);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r21.pageTitleRight || _r11);
} }
function AwResponsiveLayoutType1Component_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 26);
    ɵngcc0.ɵɵelementStart(2, "div", 21);
    ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutType1Component_div_10_ng_container_3_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, AwResponsiveLayoutType1Component_div_10_div_4_Template, 2, 1, "div", 27);
    ɵngcc0.ɵɵtemplate(5, AwResponsiveLayoutType1Component_div_10_div_5_Template, 2, 1, "div", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "div", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r11 = ɵngcc0.ɵɵreference(25);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.pageTitleLeft || _r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r2.pageTitle && (ctx_r2.mode !== ctx_r2.layoutType.C && ctx_r2.mode !== ctx_r2.layoutType.E));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.mode !== ctx_r2.layoutType.C && ctx_r2.mode !== ctx_r2.layoutType.E);
} }
function AwResponsiveLayoutType1Component_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_h1_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c5 = function (a0) { return { "m-b3": a0 }; };
function AwResponsiveLayoutType1Component_h1_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 30);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType1Component_h1_15_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c5, !ctx_r4.subtitle));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.title);
} }
function AwResponsiveLayoutType1Component_p_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_p_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 31);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType1Component_p_16_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.subtitle);
} }
function AwResponsiveLayoutType1Component_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_ng_container_18_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "aw-anchored-bottom-panel", 32);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType1Component_ng_container_18_ng_container_2_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r7.anchoredBottomPanel);
} }
function AwResponsiveLayoutType1Component_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_21_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵelement(1, "div", 28);
    ɵngcc0.ɵɵelementStart(2, "div", 34);
    ɵngcc0.ɵɵelementStart(3, "div", 35);
    ɵngcc0.ɵɵelementStart(4, "div", 36);
    ɵngcc0.ɵɵtemplate(5, AwResponsiveLayoutType1Component_div_21_ng_container_5_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.footer);
} }
function AwResponsiveLayoutType1Component_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType1Component_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
const _c6 = function (a0, a1) { return { "has-anchoredBottomPanel": a0, "hasFooter": a1 }; };
const _c7 = function (a1) { return { "layout-step-header-mobile aw-hide-on-large-only flex items-center": true, "modeC": a1 }; };
function AwResponsiveLayoutType3Component_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType3Component_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.navigation);
} }
function AwResponsiveLayoutType3Component_ng_container_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType3Component_ng_container_7_ng_container_2_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.breadcrumbs);
} }
function AwResponsiveLayoutType3Component_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType3Component_ng_container_8_ng_container_2_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.mobileBreadcrumbs || ctx_r2.breadcrumbs);
} }
function AwResponsiveLayoutType3Component_div_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_div_9_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_div_9_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType3Component_div_9_div_4_ng_container_1_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.stepperCenter);
} }
function AwResponsiveLayoutType3Component_div_9_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "div", 18);
    ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutType3Component_div_9_ng_container_3_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, AwResponsiveLayoutType3Component_div_9_div_4_Template, 2, 1, "div", 19);
    ɵngcc0.ɵɵelementStart(5, "div", 20);
    ɵngcc0.ɵɵtemplate(6, AwResponsiveLayoutType3Component_div_9_ng_container_6_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r8 = ɵngcc0.ɵɵreference(20);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.stepperLeft || _r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r3.stepperCenter);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.stepperRight || _r8);
} }
function AwResponsiveLayoutType3Component_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_container_16_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "aw-anchored-bottom-panel");
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType3Component_ng_container_16_ng_container_2_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.anchoredBottomPanel);
} }
function AwResponsiveLayoutType3Component_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType3Component_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
const _c8 = function (a0) { return { "color-strip-gradient": a0, "color-strip hue1": true }; };
function AwResponsiveLayoutType2Component_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType2Component_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.navigation);
} }
function AwResponsiveLayoutType2Component_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_div_6_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.topPanel);
} }
function AwResponsiveLayoutType2Component_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_div_8_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function AwResponsiveLayoutType2Component_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_div_9_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function AwResponsiveLayoutType2Component_div_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "div", 18);
    ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutType2Component_div_10_ng_container_3_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.getBCClasses());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function AwResponsiveLayoutType2Component_ng_container_11_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutType2Component_ng_container_11_ng_container_3_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.footer);
} }
function AwResponsiveLayoutType2Component_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_ng_template_14_div_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r17.titleImage);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_h1_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_h1_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 28);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_ng_template_14_div_0_h1_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c5, !ctx_r18.subtitle));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r18.title);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_p_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 29);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_ng_template_14_div_0_p_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r19.subtitle);
} }
function AwResponsiveLayoutType2Component_ng_template_14_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutType2Component_ng_template_14_div_0_div_1_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType2Component_ng_template_14_div_0_h1_2_Template, 2, 4, "h1", 25);
    ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutType2Component_ng_template_14_div_0_p_3_Template, 2, 1, "p", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r15.titleImage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r15.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r15.subtitle && !!ctx_r15.title);
} }
function AwResponsiveLayoutType2Component_ng_template_14_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwResponsiveLayoutType2Component_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AwResponsiveLayoutType2Component_ng_template_14_div_0_Template, 4, 3, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutType2Component_ng_template_14_ng_container_2_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r8.titleImage || !!ctx_r8.subtitle || !!ctx_r8.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("m-b0", !!ctx_r8.footer)("pt15", !ctx_r8.titleImage && !ctx_r8.subtitle && !ctx_r8.title)("m-b0", !ctx_r8.footer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.content);
} }
class AwLayoutProvider {
    constructor() {
        this.subjects = {
            anchoredBottomPanel: new Subject(),
            stepperLeft: new Subject(),
            stepperCenter: new Subject(),
            stepperRight: new Subject(),
            breadcrumbs: new Subject(),
            mobileBreadcrumbs: new Subject(),
            content: new Subject(),
            footer: new Subject(),
            header: new Subject(),
            pageTitle: new Subject(),
            mobilePageTitle: new Subject(),
            pageTitleLeft: new Subject(),
            mobilePageTitleLeft: new Subject(),
            pageTitleRight: new Subject(),
            mobilePageTitleRight: new Subject(),
            subheader: new Subject(),
            titleImage: new Subject(),
            topPanel: new Subject(),
            globalFooter: new Subject(),
            floatingDialog: new Subject(),
            progressStepper: new Subject(),
            navigation: new Subject()
        };
    }
    registerElement(type, element) {
        if (!this.subjects[type]) {
            throw new Error(`${type} is unknown elements of AwResponsiveLayout`);
        }
        this.subjects[type].next(element);
    }
    ngOnDestroy() {
        Object.values(this.subjects).forEach((v) => v.complete());
    }
}
AwLayoutProvider.ɵfac = function AwLayoutProvider_Factory(t) { return new (t || AwLayoutProvider)(); };
AwLayoutProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AwLayoutProvider, factory: AwLayoutProvider.ɵfac });
AwLayoutProvider.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwLayoutProvider, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AwResponsiveLayoutComponent extends AwComponent {
    constructor(ref, layout, changeDetector) {
        super();
        this.ref = ref;
        this.elementId = 'aw-responsive-layout-main-content';
        this.layoutElements = {};
        this.takeUntilSubject$ = new Subject();
        Object.keys(layout.subjects).forEach((key) => {
            layout.subjects[key].pipe(takeUntil(this.takeUntilSubject$)).subscribe((value) => {
                this.layoutElements[key] = value;
                changeDetector.markForCheck();
            });
        });
    }
    get someField() {
        return !!this.layoutElements.navigation;
    }
    get class() {
        return (this.mode ? `mode-${this.mode.toLowerCase()} ` : '') + (this.type ? this.type.toLocaleLowerCase() : '');
    }
    onResize() {
        this.reSetAwVhUnit();
    }
    onOrientationchange() {
        this.reSetAwVhUnit();
    }
    reSetAwVhUnit() {
        const vh = window.innerHeight * 0.01;
        this.ref.nativeElement.style.setProperty('--aw_vh', `${vh}px`);
    }
    getMobileBackgroundUrl() {
        this.mobileBackgroundUrl = this.mobileBackgroundUrl || '';
        return `url(${this.mobileBackgroundUrl})`;
    }
    getDesktopBackgroundUrl() {
        this.desktopBackgroundUrl = this.desktopBackgroundUrl || '';
        return `url(${this.desktopBackgroundUrl})`;
    }
    getCSSClass() {
        return `${this.styleClasses} ${this.desktopBackgroundUrl && this.mobileBackgroundUrl ? 'no-bg' : ''}`;
    }
    ngAfterViewInit() {
        this.reSetAwVhUnit();
    }
    ngOnDestroy() {
        this.takeUntilSubject$.next();
        this.takeUntilSubject$.complete();
    }
}
AwResponsiveLayoutComponent.ɵfac = function AwResponsiveLayoutComponent_Factory(t) { return new (t || AwResponsiveLayoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(AwLayoutProvider), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AwResponsiveLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwResponsiveLayoutComponent, selectors: [["aw-responsive-layout"]], hostVars: 4, hostBindings: function AwResponsiveLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function AwResponsiveLayoutComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("orientationchange", function AwResponsiveLayoutComponent_orientationchange_HostBindingHandler() { return ctx.onOrientationchange(); }, false, ɵngcc0.ɵɵresolveWindow);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
        ɵngcc0.ɵɵclassProp("has-navigation", ctx.someField);
    } }, inputs: { elementId: "elementId", mobileBackgroundUrl: "mobileBackgroundUrl", desktopBackgroundUrl: "desktopBackgroundUrl", fullWidth: "fullWidth", fullscreen: "fullscreen", fullscreenOnSmall: "fullscreenOnSmall", styleClasses: "styleClasses", type: "type", mode: "mode", globalFooter: "globalFooter", fullWideContentArea: "fullWideContentArea", sixColumnContent: "sixColumnContent", stripBannerGradient: "stripBannerGradient", fixedHeight: "fixedHeight" }, features: [ɵngcc0.ɵɵProvidersFeature([AwLayoutProvider]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 7, vars: 4, consts: [[3, "ngSwitch"], [3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "anchoredBottomPanel", "automationValue", "footer", "content", "title", "subtitle", "pageTitle", "mobilePageTitle", "pageTitleLeft", "mobilePageTitleLeft", "pageTitleRight", "mobilePageTitleRight", "globalFooter", "mode", "floatingDialog", "fullWideContentArea", "sixColumnContent", "progressStepper", "navigation", "fixedHeight", 4, "ngSwitchCase"], [3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "mode", "footer", "content", "titleImage", "title", "subtitle", "topPanel", "globalFooter", "automationValue", "navigation", "fixedHeight", 4, "ngSwitchCase"], [3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "anchoredBottomPanel", "stepperLeft", "stepperCenter", "stepperRight", "title", "breadcrumbs", "mobileBreadcrumbs", "content", "globalFooter", "automationValue", "mode", "stripBannerGradient", "navigation", "fixedHeight", 4, "ngSwitchCase"], [3, "fullWidth", "fullscreen", "fullscreenOnSmall", "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "automationValue", "fixedHeight", 4, "ngSwitchDefault"], ["empty", ""], [3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "anchoredBottomPanel", "automationValue", "footer", "content", "title", "subtitle", "pageTitle", "mobilePageTitle", "pageTitleLeft", "mobilePageTitleLeft", "pageTitleRight", "mobilePageTitleRight", "globalFooter", "mode", "floatingDialog", "fullWideContentArea", "sixColumnContent", "progressStepper", "navigation", "fixedHeight"], [3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "mode", "footer", "content", "titleImage", "title", "subtitle", "topPanel", "globalFooter", "automationValue", "navigation", "fixedHeight"], [3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "anchoredBottomPanel", "stepperLeft", "stepperCenter", "stepperRight", "title", "breadcrumbs", "mobileBreadcrumbs", "content", "globalFooter", "automationValue", "mode", "stripBannerGradient", "navigation", "fixedHeight"], [3, "fullWidth", "fullscreen", "fullscreenOnSmall", "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "automationValue", "fixedHeight"]], template: function AwResponsiveLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, AwResponsiveLayoutComponent_aw_responsive_layout_type1_1_Template, 1, 24, "aw-responsive-layout-type1", 1);
        ɵngcc0.ɵɵtemplate(2, AwResponsiveLayoutComponent_aw_responsive_layout_type2_2_Template, 1, 15, "aw-responsive-layout-type2", 2);
        ɵngcc0.ɵɵtemplate(3, AwResponsiveLayoutComponent_aw_responsive_layout_type3_3_Template, 1, 18, "aw-responsive-layout-type3", 3);
        ɵngcc0.ɵɵtemplate(4, AwResponsiveLayoutComponent_aw_responsive_layout_base_4_Template, 5, 9, "aw-responsive-layout-base", 4);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(5, AwResponsiveLayoutComponent_ng_template_5_Template, 1, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Type1");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Type2");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Type3");
    } }, directives: function () { return [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, AwResponsiveLayoutType1Component, AwResponsiveLayoutType2Component, AwResponsiveLayoutType3Component, AwResponsiveLayoutBaseComponent]; }, encapsulation: 2 });
AwResponsiveLayoutComponent.selectorDowngrade = 'aw-responsive-layout';
AwResponsiveLayoutComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: AwLayoutProvider },
    { type: ChangeDetectorRef }
];
AwResponsiveLayoutComponent.propDecorators = {
    fullWidth: [{ type: Input }],
    fullscreen: [{ type: Input }],
    fullscreenOnSmall: [{ type: Input }],
    styleClasses: [{ type: Input }],
    elementId: [{ type: Input }],
    mobileBackgroundUrl: [{ type: Input }],
    desktopBackgroundUrl: [{ type: Input }],
    type: [{ type: Input }],
    mode: [{ type: Input }],
    globalFooter: [{ type: Input }],
    fullWideContentArea: [{ type: Input }],
    sixColumnContent: [{ type: Input }],
    stripBannerGradient: [{ type: Input }],
    fixedHeight: [{ type: Input }],
    someField: [{ type: HostBinding, args: ['class.has-navigation',] }],
    class: [{ type: HostBinding, args: ['class',] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }],
    onOrientationchange: [{ type: HostListener, args: ['window:orientationchange',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwResponsiveLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'aw-responsive-layout',
                template: "\n<ng-container [ngSwitch]=\"type\">\n    <aw-responsive-layout-type1\n        *ngSwitchCase=\"'Type1'\"\n        styleClasses=\"{{styleClasses}} type1\"\n        [elementId]=\"elementId\"\n        [mobileBackgroundUrl]=\"mobileBackgroundUrl\"\n        [desktopBackgroundUrl]=\"desktopBackgroundUrl\"\n        [anchoredBottomPanel]=\"layoutElements.anchoredBottomPanel\"\n        [automationValue]=\"automationValue\"\n        [footer]=\"layoutElements.footer\"\n        [content]=\"layoutElements.content\"\n        [title]=\"layoutElements.header\"\n        [subtitle]=\"layoutElements.subheader\"\n        [pageTitle]=\"layoutElements.pageTitle\"\n        [mobilePageTitle]=\"layoutElements.mobilePageTitle\"\n        [pageTitleLeft]=\"layoutElements.pageTitleLeft\"\n        [mobilePageTitleLeft]=\"layoutElements.mobilePageTitleLeft\"\n        [pageTitleRight]=\"layoutElements.pageTitleRight\"\n        [mobilePageTitleRight]=\"layoutElements.mobilePageTitleRight\"\n        [globalFooter]=\"layoutElements.globalFooter\"\n        [mode]=\"mode\"\n        [floatingDialog]=\"layoutElements.floatingDialog\"\n        [fullWideContentArea]=\"fullWideContentArea\"\n        [sixColumnContent]=\"sixColumnContent\"\n        [progressStepper]=\"layoutElements.progressStepper\"\n        [navigation]=\"layoutElements.navigation\"\n        [fixedHeight]=\"fixedHeight\"\n    >\n    </aw-responsive-layout-type1>\n    <aw-responsive-layout-type2\n        *ngSwitchCase=\"'Type2'\"\n        [styleClasses]=\"styleClasses\"\n        [elementId]=\"elementId\"\n        [mobileBackgroundUrl]=\"mobileBackgroundUrl\"\n        [desktopBackgroundUrl]=\"desktopBackgroundUrl\"\n        [mode]=\"mode\"\n        [footer]=\"layoutElements.footer\"\n        [content]=\"layoutElements.content\"\n        [titleImage]=\"layoutElements.titleImage\"\n        [title]=\"layoutElements.header\"\n        [subtitle]=\"layoutElements.subheader\"\n        [topPanel]=\"layoutElements.topPanel\"\n        [globalFooter]=\"layoutElements.globalFooter\"\n        [automationValue]=\"automationValue\"\n        [navigation]=\"layoutElements.navigation\"\n        [fixedHeight]=\"fixedHeight\"\n    >\n    </aw-responsive-layout-type2>\n    <aw-responsive-layout-type3\n        *ngSwitchCase=\"'Type3'\"\n        [styleClasses]=\"styleClasses\"\n        [elementId]=\"elementId\"\n        [mobileBackgroundUrl]=\"mobileBackgroundUrl\"\n        [desktopBackgroundUrl]=\"desktopBackgroundUrl\"\n        [anchoredBottomPanel]=\"layoutElements.anchoredBottomPanel\"\n        [stepperLeft]=\"layoutElements.stepperLeft\"\n        [stepperCenter]=\"layoutElements.stepperCenter\"\n        [stepperRight]=\"layoutElements.stepperRight\"\n        [title]=\"layoutElements.header\"\n        [breadcrumbs]=\"layoutElements.breadcrumbs\"\n        [mobileBreadcrumbs]=\"layoutElements.mobileBreadcrumbs\"\n        [content]=\"layoutElements.content\"\n        [globalFooter]=\"layoutElements.globalFooter\"\n        [automationValue]=\"automationValue\"\n        [mode]=\"mode\"\n        [stripBannerGradient]=\"stripBannerGradient\"\n        [navigation]=\"layoutElements.navigation\"\n        [fixedHeight]=\"fixedHeight\"\n    >\n    </aw-responsive-layout-type3>  \n    <aw-responsive-layout-base\n        *ngSwitchDefault\n        [fullWidth]=\"fullWidth\"\n        [fullscreen]=\"fullscreen\"\n        [fullscreenOnSmall]=\"fullscreenOnSmall\"\n        [styleClasses]=\"styleClasses\"\n        [elementId]=\"elementId\"\n        [mobileBackgroundUrl]=\"mobileBackgroundUrl\"\n        [desktopBackgroundUrl]=\"desktopBackgroundUrl\"\n        [automationValue]=\"automationValue\"\n        [fixedHeight]=\"fixedHeight\"\n    >\n        <ng-content select=\"[aw-responsive-layout-header]\" ngProjectAs=\"[aw-responsive-layout-header]\"></ng-content>\n        <ng-content select=\"[aw-responsive-layout-content]\" ngProjectAs=\"[aw-responsive-layout-content]\"></ng-content>\n        <ng-content select=\"[aw-responsive-layout-footer]\" ngProjectAs=\"[aw-responsive-layout-footer]\"></ng-content>\n        <ng-content select=\"[aw-responsive-layout-floating-dialog]\" ngProjectAs=\"[aw-responsive-layout-floating-dialog]\"></ng-content>\n    </aw-responsive-layout-base>\n\n</ng-container> \n\n<ng-template #empty><span></span></ng-template>",
                providers: [AwLayoutProvider]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: AwLayoutProvider }, { type: ɵngcc0.ChangeDetectorRef }]; }, { elementId: [{
            type: Input
        }], someField: [{
            type: HostBinding,
            args: ['class.has-navigation']
        }], class: [{
            type: HostBinding,
            args: ['class']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], onOrientationchange: [{
            type: HostListener,
            args: ['window:orientationchange']
        }], mobileBackgroundUrl: [{
            type: Input
        }], desktopBackgroundUrl: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }], fullscreenOnSmall: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], type: [{
            type: Input
        }], mode: [{
            type: Input
        }], globalFooter: [{
            type: Input
        }], fullWideContentArea: [{
            type: Input
        }], sixColumnContent: [{
            type: Input
        }], stripBannerGradient: [{
            type: Input
        }], fixedHeight: [{
            type: Input
        }] }); })();

class AwResponsiveLayoutBaseComponent extends AwComponent {
    constructor(ref) {
        super();
        this.ref = ref;
        this.elementId = 'aw-responsive-layout-main-content';
    }
    onResize() {
        this.reSetAwVhUnit();
    }
    onOrientationchange() {
        this.reSetAwVhUnit();
    }
    reSetAwVhUnit() {
        const vh = window.innerHeight * 0.01;
        this.ref.nativeElement.style.setProperty('--aw_vh', `${vh}px`);
    }
    getMobileBackgroundUrl() {
        this.mobileBackgroundUrl = this.mobileBackgroundUrl || '';
        return `url(${this.mobileBackgroundUrl})`;
    }
    getDesktopBackgroundUrl() {
        this.desktopBackgroundUrl = this.desktopBackgroundUrl || '';
        return `url(${this.desktopBackgroundUrl})`;
    }
    getCSSClass() {
        return `${this.styleClasses} ${this.desktopBackgroundUrl && this.mobileBackgroundUrl ? 'no-bg' : ''}`;
    }
    ngAfterViewInit() {
        this.reSetAwVhUnit();
    }
}
AwResponsiveLayoutBaseComponent.ɵfac = function AwResponsiveLayoutBaseComponent_Factory(t) { return new (t || AwResponsiveLayoutBaseComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AwResponsiveLayoutBaseComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwResponsiveLayoutBaseComponent, selectors: [["aw-responsive-layout-base"]], hostBindings: function AwResponsiveLayoutBaseComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function AwResponsiveLayoutBaseComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("orientationchange", function AwResponsiveLayoutBaseComponent_orientationchange_HostBindingHandler() { return ctx.onOrientationchange(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { elementId: "elementId", mobileBackgroundUrl: "mobileBackgroundUrl", desktopBackgroundUrl: "desktopBackgroundUrl", fullWidth: "fullWidth", fullscreen: "fullscreen", fullscreenOnSmall: "fullscreenOnSmall", styleClasses: "styleClasses", justifyCenter: "justifyCenter", isMultiColumnLayout: "isMultiColumnLayout", fixedHeight: "fixedHeight" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 9, vars: 19, consts: [[1, "aw-layout-bg", "aw-hide-on-med-and-down", 3, "ngStyle"], [1, "aw-layout-bg", "aw-hide-on-large-only", 3, "ngStyle"], ["tabindex", "-1", 1, "scroll-template", 3, "ngClass"], [1, "flex", "flex-column", "h100", "w100", "rel"], [1, "aw-container", "main-content"]], template: function AwResponsiveLayoutBaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "section", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(8, 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(15, _c3, ctx.getDesktopBackgroundUrl()));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(17, _c3, ctx.getMobileBackgroundUrl()));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getCSSClass());
        ɵngcc0.ɵɵattribute("automation", ctx.automationValue || "responsiveLayoutComponent")("id", ctx.elementId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("justify-center", ctx.justifyCenter)("fullwidth", ctx.fullWidth)("fullscreen", ctx.fullscreen)("fullscreen-on-small", ctx.fullscreenOnSmall)("fixed-height", ctx.fixedHeight);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass], encapsulation: 2 });
AwResponsiveLayoutBaseComponent.selectorDowngrade = 'aw-responsive-layout';
AwResponsiveLayoutBaseComponent.ctorParameters = () => [
    { type: ElementRef }
];
AwResponsiveLayoutBaseComponent.propDecorators = {
    fullWidth: [{ type: Input }],
    fullscreen: [{ type: Input }],
    fullscreenOnSmall: [{ type: Input }],
    styleClasses: [{ type: Input }],
    justifyCenter: [{ type: Input }],
    elementId: [{ type: Input }],
    mobileBackgroundUrl: [{ type: Input }],
    desktopBackgroundUrl: [{ type: Input }],
    isMultiColumnLayout: [{ type: Input }],
    fixedHeight: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize',] }],
    onOrientationchange: [{ type: HostListener, args: ['window:orientationchange',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwResponsiveLayoutBaseComponent, [{
        type: Component,
        args: [{
                selector: 'aw-responsive-layout-base',
                template: "<div class=\"aw-layout-bg aw-hide-on-med-and-down\"\n    [ngStyle]=\"{'background-image': getDesktopBackgroundUrl()}\"></div>\n<div class=\"aw-layout-bg aw-hide-on-large-only\"\n    [ngStyle]=\"{'background-image': getMobileBackgroundUrl()}\"></div>\n<ng-content select=\"[aw-responsive-layout-header]\"></ng-content>\n<div class=\"scroll-template\"\n    [ngClass]=\"getCSSClass()\"\n    [attr.automation]=\"automationValue || 'responsiveLayoutComponent'\"\n    [attr.id]=\"elementId\"\n    tabindex=\"-1\">\n    <section class=\"flex flex-column h100 w100 rel\">\n        <div class=\"aw-container main-content\"\n            [class.justify-center]=\"justifyCenter\"\n            [class.fullwidth]=\"fullWidth\"\n            [class.fullscreen]=\"fullscreen\"\n            [class.fullscreen-on-small]=\"fullscreenOnSmall\"\n            [class.fixed-height]=\"fixedHeight\">\n            <ng-content select=\"[aw-responsive-layout-content]\"></ng-content>\n            <ng-content select=\"[aw-responsive-layout-floating-dialog]\"></ng-content>\n        </div>\n    </section>\n</div>\n<ng-content select=\"[aw-responsive-layout-footer]\"></ng-content>\n\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { elementId: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], onOrientationchange: [{
            type: HostListener,
            args: ['window:orientationchange']
        }], mobileBackgroundUrl: [{
            type: Input
        }], desktopBackgroundUrl: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }], fullscreenOnSmall: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], justifyCenter: [{
            type: Input
        }], isMultiColumnLayout: [{
            type: Input
        }], fixedHeight: [{
            type: Input
        }] }); })();

class AwResponsiveLayoutType1Component extends AwComponent {
    constructor() {
        super(...arguments);
        this.layoutType = LAYOUT_TYPES;
    }
    getClasses() {
        const sixColumnsClass = this.sixColumnContent ? 'offset-xl3 xl6 offset-l2 l8' : 'offset-xl2 xl8 offset-l1 l10';
        return `col s12 ${this.fullWideContentArea ? '' : sixColumnsClass} pt3 aw-form-indent-small-16 aw-form-indent`;
    }
}
AwResponsiveLayoutType1Component.ɵfac = function AwResponsiveLayoutType1Component_Factory(t) { return ɵAwResponsiveLayoutType1Component_BaseFactory(t || AwResponsiveLayoutType1Component); };
AwResponsiveLayoutType1Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwResponsiveLayoutType1Component, selectors: [["aw-responsive-layout-type1"]], inputs: { fullWidth: "fullWidth", fullscreen: "fullscreen", fullscreenOnSmall: "fullscreenOnSmall", styleClasses: "styleClasses", elementId: "elementId", mobileBackgroundUrl: "mobileBackgroundUrl", desktopBackgroundUrl: "desktopBackgroundUrl", anchoredBottomPanel: "anchoredBottomPanel", type: "type", mode: "mode", title: "title", subtitle: "subtitle", footer: "footer", content: "content", pageTitle: "pageTitle", mobilePageTitle: "mobilePageTitle", pageTitleLeft: "pageTitleLeft", mobilePageTitleLeft: "mobilePageTitleLeft", pageTitleRight: "pageTitleRight", mobilePageTitleRight: "mobilePageTitleRight", globalFooter: "globalFooter", floatingDialog: "floatingDialog", fullWideContentArea: "fullWideContentArea", sixColumnContent: "sixColumnContent", progressStepper: "progressStepper", navigation: "navigation", fixedHeight: "fixedHeight" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 26, vars: 29, consts: [[4, "ngIf"], ["fullscreenOnSmall", "true", 1, "ml-full-x", 3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "automationValue", "fixedHeight", "ngClass"], ["aw-responsive-layout-header", "", 3, "ngClass"], [1, "aw-container", "h100"], [1, "aw-row", "m-b0", "h100"], ["class", "col s12 flex flex-row items-center justify-between h100", 4, "ngIf"], ["aw-responsive-layout-content", ""], [1, "aw-row"], [1, "col", "s12"], [1, "layout-content"], [4, "ngTemplateOutlet"], [1, "aw-row", "flex-regular", "m-b25"], [3, "ngClass"], ["class", "h3", "automation", "pageHeader", 3, "ngClass", 4, "ngIf"], ["class", "neutral7-text m-b3", "automation", "pageSubheader", 4, "ngIf"], ["aw-responsive-layout-floating-dialog", ""], ["automation", "pageFooter", "class", "aw-hide-on-med-and-down", 4, "ngIf"], ["ngProjectAs", "[aw-responsive-layout-footer]", 5, ["", "aw-responsive-layout-footer", ""]], ["empty", ""], [1, "ml-full-x"], [1, "col", "s12", "flex", "flex-row", "items-center", "justify-between", "h100"], [1, "layout-stepper-item", "layout-stepper-item-left"], ["class", "layout-stepper-item", 4, "ngIf"], ["class", "layout-stepper-item layout-stepper-item-right", 4, "ngIf"], [1, "layout-stepper-item"], [1, "layout-stepper-item", "layout-stepper-item-right"], [1, "flex", "flex-row", "items-center", "justify-between", "py1", "type1-header"], ["class", "layout-stepper-item layout-stepper-item", 4, "ngIf"], [1, "aw-divider"], [1, "layout-stepper-item", "layout-stepper-item"], ["automation", "pageHeader", 1, "h3", 3, "ngClass"], ["automation", "pageSubheader", 1, "neutral7-text", "m-b3"], ["stickyBoundaryContainer", ".layout-content"], ["automation", "pageFooter", 1, "aw-hide-on-med-and-down"], [1, "aw-row", "m-b0"], [1, "col", "offset-s1", "s10", "offset-xl2", "xl8"], [1, "px2", "py15", "center-align"]], template: function AwResponsiveLayoutType1Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AwResponsiveLayoutType1Component_div_0_Template, 3, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "aw-responsive-layout-base", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, AwResponsiveLayoutType1Component_div_5_Template, 5, 3, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵtemplate(10, AwResponsiveLayoutType1Component_div_10_Template, 7, 3, "div", 0);
        ɵngcc0.ɵɵtemplate(11, AwResponsiveLayoutType1Component_ng_container_11_Template, 1, 0, "ng-container", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵelementStart(13, "div", 12);
        ɵngcc0.ɵɵelementContainerStart(14);
        ɵngcc0.ɵɵtemplate(15, AwResponsiveLayoutType1Component_h1_15_Template, 2, 4, "h1", 13);
        ɵngcc0.ɵɵtemplate(16, AwResponsiveLayoutType1Component_p_16_Template, 2, 1, "p", 14);
        ɵngcc0.ɵɵtemplate(17, AwResponsiveLayoutType1Component_ng_container_17_Template, 1, 0, "ng-container", 10);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, AwResponsiveLayoutType1Component_ng_container_18_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(19, "div", 15);
        ɵngcc0.ɵɵtemplate(20, AwResponsiveLayoutType1Component_ng_container_20_Template, 1, 0, "ng-container", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(21, AwResponsiveLayoutType1Component_div_21_Template, 6, 1, "div", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(22, 17);
        ɵngcc0.ɵɵtemplate(23, AwResponsiveLayoutType1Component_ng_container_23_Template, 1, 0, "ng-container", 10);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(24, AwResponsiveLayoutType1Component_ng_template_24_Template, 1, 0, "ng-template", null, 18, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r11 = ɵngcc0.ɵɵreference(25);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navigation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("styleClasses", ctx.styleClasses)("elementId", ctx.elementId)("mobileBackgroundUrl", ctx.mobileBackgroundUrl)("desktopBackgroundUrl", ctx.desktopBackgroundUrl)("automationValue", ctx.automationValue)("fixedHeight", ctx.fixedHeight)("ngClass", ɵngcc0.ɵɵpureFunction2(24, _c6, ctx.anchoredBottomPanel, ctx.globalFooter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c7, ctx.mode === "C"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode !== ctx.layoutType.B && ctx.mode !== ctx.layoutType.D);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("aw-form-indent-small-16", ctx.mode !== ctx.layoutType.B);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode !== ctx.layoutType.B && ctx.mode !== ctx.layoutType.D);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.progressStepper || _r11);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("m-0", ctx.mode === ctx.layoutType.A || ctx.mode === ctx.layoutType.C);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getClasses());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.subtitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.content);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.anchoredBottomPanel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.floatingDialog);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.footer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.globalFooter);
    } }, directives: [ɵngcc1.NgIf, AwResponsiveLayoutBaseComponent, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet, ɵngcc2.AwAnchoredBottomPanelComponent], encapsulation: 2 });
AwResponsiveLayoutType1Component.propDecorators = {
    fullWidth: [{ type: Input }],
    fullscreen: [{ type: Input }],
    fullscreenOnSmall: [{ type: Input }],
    styleClasses: [{ type: Input }],
    elementId: [{ type: Input }],
    mobileBackgroundUrl: [{ type: Input }],
    desktopBackgroundUrl: [{ type: Input }],
    anchoredBottomPanel: [{ type: Input }],
    type: [{ type: Input }],
    mode: [{ type: Input }],
    title: [{ type: Input }],
    subtitle: [{ type: Input }],
    footer: [{ type: Input }],
    content: [{ type: Input }],
    pageTitle: [{ type: Input }],
    mobilePageTitle: [{ type: Input }],
    pageTitleLeft: [{ type: Input }],
    mobilePageTitleLeft: [{ type: Input }],
    pageTitleRight: [{ type: Input }],
    mobilePageTitleRight: [{ type: Input }],
    globalFooter: [{ type: Input }],
    floatingDialog: [{ type: Input }],
    fullWideContentArea: [{ type: Input }],
    sixColumnContent: [{ type: Input }],
    progressStepper: [{ type: Input }],
    navigation: [{ type: Input }],
    fixedHeight: [{ type: Input }]
};
const ɵAwResponsiveLayoutType1Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwResponsiveLayoutType1Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwResponsiveLayoutType1Component, [{
        type: Component,
        args: [{
                selector: 'aw-responsive-layout-type1',
                template: "\n<div *ngIf=\"navigation\">\n    <div class=\"ml-full-x\"><ng-container *ngTemplateOutlet=\"navigation\"></ng-container></div>\n</div>\n<aw-responsive-layout-base\nclass=\"ml-full-x\"\nfullscreenOnSmall=\"true\"\n[styleClasses]=\"styleClasses\"\n[elementId]=\"elementId\"\n[mobileBackgroundUrl]=\"mobileBackgroundUrl\"\n[desktopBackgroundUrl]=\"desktopBackgroundUrl\"\n[automationValue]=\"automationValue\"\n[fixedHeight]=\"fixedHeight\"\n[ngClass]=\"{\n    'has-anchoredBottomPanel': anchoredBottomPanel,\n    'hasFooter' : globalFooter\n}\"\n>\n<div aw-responsive-layout-header\n    [ngClass]=\"{'layout-step-header-mobile aw-hide-on-large-only flex items-center': true, 'modeC': mode === 'C'}\"> \n    <div class=\"aw-container h100\">\n        <div class=\"aw-row m-b0 h100\">\n            <div *ngIf=\"mode !== layoutType.B && mode !== layoutType.D\" class=\"col s12 flex flex-row items-center justify-between h100\">\n                <div class=\"layout-stepper-item layout-stepper-item-left\">\n                    <ng-container *ngTemplateOutlet=\"mobilePageTitleLeft || pageTitleLeft || empty\"></ng-container>\n                </div>\n                <div class=\"layout-stepper-item\" *ngIf=\"!!(pageTitle || !!mobilePageTitle) && mode !== layoutType.C  && mode !== layoutType.E\">\n                    <ng-container *ngTemplateOutlet=\"mobilePageTitle || pageTitle\"></ng-container>\n                </div>\n                <div class=\"layout-stepper-item layout-stepper-item-right\" *ngIf=\"mode !== layoutType.C  && mode !== layoutType.E\">\n                    <ng-container *ngTemplateOutlet=\"mobilePageTitleRight || pageTitleRight || empty\"></ng-container>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div aw-responsive-layout-content>\n    <div \n        class=\"aw-row\"\n    >\n        <div \n            class=\"col s12\"\n        >\n            <div \n                class=\"layout-content\"\n                [class.aw-form-indent-small-16]=\"mode !== layoutType.B\"\n            >\n                <div *ngIf=\"mode !== layoutType.B && mode !== layoutType.D\" >\n                    <div class=\"flex flex-row items-center justify-between py1 type1-header\">\n                        <div class=\"layout-stepper-item layout-stepper-item-left\">\n                            <ng-container *ngTemplateOutlet=\"pageTitleLeft || empty\"></ng-container>\n                        </div>\n                        <div class=\"layout-stepper-item layout-stepper-item\" *ngIf=\"!!pageTitle && (mode !== layoutType.C && mode !== layoutType.E)\"><ng-container *ngTemplateOutlet=\"pageTitle\"></ng-container></div>\n                        <div class=\"layout-stepper-item layout-stepper-item-right\" *ngIf=\"mode !== layoutType.C && mode !== layoutType.E\"><ng-container *ngTemplateOutlet=\"pageTitleRight|| empty\"></ng-container></div>\n                    </div>\n                    <div class=\"aw-divider\"></div>\n                </div>\n\n                <ng-container *ngTemplateOutlet=\"progressStepper || empty\"></ng-container>\n\n                <div \n                    class=\"aw-row flex-regular m-b25\"\n                    [class.m-0]=\"mode === layoutType.A || mode === layoutType.C\"\n                >\n                    <div [ngClass]=\"getClasses()\">\n                    <ng-container>\n                        <h1 class=\"h3\"\n                            [ngClass]=\"{'m-b3':!subtitle}\"\n                            *ngIf=\"!!title\"\n                            automation=\"pageHeader\"\n                        >\n                            <ng-container *ngTemplateOutlet=\"title\"></ng-container>\n                        </h1>\n                        <p class=\"neutral7-text m-b3\"\n                           *ngIf=\"!!subtitle\"\n                           automation=\"pageSubheader\"\n                        >\n                            <ng-container *ngTemplateOutlet=\"subtitle\"></ng-container>\n                        </p>\n                        <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n                    </ng-container>\n\n                    </div>\n                </div>\n                <ng-container *ngIf=\"!!anchoredBottomPanel\">\n                    <aw-anchored-bottom-panel stickyBoundaryContainer=\".layout-content\">\n                        <ng-container *ngTemplateOutlet=\"anchoredBottomPanel\"></ng-container>\n                    </aw-anchored-bottom-panel>\n                </ng-container>\n                <div aw-responsive-layout-floating-dialog>\n                    <ng-container *ngTemplateOutlet=\"floatingDialog\"></ng-container>\n                </div>\n                <div *ngIf=\"footer\" automation=\"pageFooter\" class=\"aw-hide-on-med-and-down\">\n                    <div class=\"aw-divider\"></div>\n                    <div class=\"aw-row m-b0\">\n                        <div class=\"col offset-s1 s10 offset-xl2 xl8\">\n                            <div class=\"px2 py15 center-align\">\n                                <ng-container *ngTemplateOutlet=\"footer\"></ng-container>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <ng-container ngProjectAs=\"[aw-responsive-layout-footer]\">\n        <ng-container *ngTemplateOutlet=\"globalFooter\"></ng-container>\n    </ng-container>\n</div>\n\n</aw-responsive-layout-base>\n\n<ng-template #empty><span></span></ng-template>\n"
            }]
    }], null, { fullWidth: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }], fullscreenOnSmall: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], elementId: [{
            type: Input
        }], mobileBackgroundUrl: [{
            type: Input
        }], desktopBackgroundUrl: [{
            type: Input
        }], anchoredBottomPanel: [{
            type: Input
        }], type: [{
            type: Input
        }], mode: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], footer: [{
            type: Input
        }], content: [{
            type: Input
        }], pageTitle: [{
            type: Input
        }], mobilePageTitle: [{
            type: Input
        }], pageTitleLeft: [{
            type: Input
        }], mobilePageTitleLeft: [{
            type: Input
        }], pageTitleRight: [{
            type: Input
        }], mobilePageTitleRight: [{
            type: Input
        }], globalFooter: [{
            type: Input
        }], floatingDialog: [{
            type: Input
        }], fullWideContentArea: [{
            type: Input
        }], sixColumnContent: [{
            type: Input
        }], progressStepper: [{
            type: Input
        }], navigation: [{
            type: Input
        }], fixedHeight: [{
            type: Input
        }] }); })();

class AwResponsiveLayoutType3Component extends AwComponent {
    onClick(event) {
        event.preventDefault();
    }
    get hasStepper() {
        return !!this.stepperLeft || !!this.stepperCenter || !!this.stepperRight;
    }
}
AwResponsiveLayoutType3Component.ɵfac = function AwResponsiveLayoutType3Component_Factory(t) { return ɵAwResponsiveLayoutType3Component_BaseFactory(t || AwResponsiveLayoutType3Component); };
AwResponsiveLayoutType3Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwResponsiveLayoutType3Component, selectors: [["aw-responsive-layout-type3"]], inputs: { fullWidth: "fullWidth", mode: "mode", fullscreen: "fullscreen", fullscreenOnSmall: "fullscreenOnSmall", styleClasses: "styleClasses", elementId: "elementId", mobileBackgroundUrl: "mobileBackgroundUrl", desktopBackgroundUrl: "desktopBackgroundUrl", anchoredBottomPanel: "anchoredBottomPanel", title: "title", content: "content", breadcrumbs: "breadcrumbs", mobileBreadcrumbs: "mobileBreadcrumbs", globalFooter: "globalFooter", stepperLeft: "stepperLeft", stepperCenter: "stepperCenter", stepperRight: "stepperRight", stripBannerGradient: "stripBannerGradient", navigation: "navigation", fixedHeight: "fixedHeight" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 21, vars: 17, consts: [[4, "ngIf"], [1, "ml-full-x", 3, "styleClasses", "elementId", "automationValue", "fixedHeight"], ["aw-responsive-layout-content", ""], [3, "ngClass"], [1, "aw-row", "m-b25"], [1, "col", "s12"], ["class", "type3-stepper", 4, "ngIf"], [1, "layout-mt"], ["automation", "pageHeader", 1, "m-b3"], [4, "ngTemplateOutlet"], ["automation", "pageContent"], ["ngProjectAs", "[aw-responsive-layout-footer]", 5, ["", "aw-responsive-layout-footer", ""]], ["empty", ""], [1, "ml-full-x", "ml-full-top"], [1, "aw-hide-on-med-and-down"], [1, "aw-hide-on-large-only"], [1, "type3-stepper"], [1, "aw-container", "flex", "flex-row"], [1, "layout-stepper-item", "layout-stepper-item-left"], ["class", "layout-stepper-item", 4, "ngIf"], [1, "layout-stepper-item", "layout-stepper-item-right"], [1, "layout-stepper-item"]], template: function AwResponsiveLayoutType3Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AwResponsiveLayoutType3Component_ng_container_0_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(1, "aw-responsive-layout-base", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementContainerStart(6);
        ɵngcc0.ɵɵtemplate(7, AwResponsiveLayoutType3Component_ng_container_7_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(8, AwResponsiveLayoutType3Component_ng_container_8_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(9, AwResponsiveLayoutType3Component_div_9_Template, 7, 3, "div", 6);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵelementContainerStart(11);
        ɵngcc0.ɵɵelementStart(12, "h1", 8);
        ɵngcc0.ɵɵtemplate(13, AwResponsiveLayoutType3Component_ng_container_13_Template, 1, 0, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 10);
        ɵngcc0.ɵɵtemplate(15, AwResponsiveLayoutType3Component_ng_container_15_Template, 1, 0, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, AwResponsiveLayoutType3Component_ng_container_16_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵelementContainerStart(17, 11);
        ɵngcc0.ɵɵtemplate(18, AwResponsiveLayoutType3Component_ng_container_18_Template, 1, 0, "ng-container", 9);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, AwResponsiveLayoutType3Component_ng_template_19_Template, 1, 0, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.navigation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hasFooter", ctx.globalFooter);
        ɵngcc0.ɵɵproperty("styleClasses", ctx.styleClasses)("elementId", ctx.elementId)("automationValue", ctx.automationValue)("fixedHeight", ctx.fixedHeight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c8, ctx.stripBannerGradient));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.breadcrumbs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.mobileBreadcrumbs || !!ctx.breadcrumbs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasStepper);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.content);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.anchoredBottomPanel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.globalFooter);
    } }, directives: [ɵngcc1.NgIf, AwResponsiveLayoutBaseComponent, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet, ɵngcc2.AwAnchoredBottomPanelComponent], encapsulation: 2 });
AwResponsiveLayoutType3Component.propDecorators = {
    fullWidth: [{ type: Input }],
    mode: [{ type: Input }],
    fullscreen: [{ type: Input }],
    fullscreenOnSmall: [{ type: Input }],
    styleClasses: [{ type: Input }],
    elementId: [{ type: Input }],
    mobileBackgroundUrl: [{ type: Input }],
    desktopBackgroundUrl: [{ type: Input }],
    anchoredBottomPanel: [{ type: Input }],
    title: [{ type: Input }],
    content: [{ type: Input }],
    breadcrumbs: [{ type: Input }],
    mobileBreadcrumbs: [{ type: Input }],
    globalFooter: [{ type: Input }],
    stepperLeft: [{ type: Input }],
    stepperCenter: [{ type: Input }],
    stepperRight: [{ type: Input }],
    stripBannerGradient: [{ type: Input }],
    navigation: [{ type: Input }],
    fixedHeight: [{ type: Input }]
};
const ɵAwResponsiveLayoutType3Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwResponsiveLayoutType3Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwResponsiveLayoutType3Component, [{
        type: Component,
        args: [{
                selector: 'aw-responsive-layout-type3',
                template: "<ng-container *ngIf=\"navigation\">\n    <div class=\"ml-full-x ml-full-top\"><ng-container *ngTemplateOutlet=\"navigation\"></ng-container></div>\n</ng-container>\n<aw-responsive-layout-base \n    class=\"ml-full-x\"\n    [styleClasses]=\"styleClasses\" \n    [elementId]=\"elementId\" \n    [automationValue]=\"automationValue\"\n    [class.hasFooter]=\"globalFooter\" \n    [fixedHeight]=\"fixedHeight\"\n>\n    <div aw-responsive-layout-content>\n        <div [ngClass]=\"{'color-strip-gradient': stripBannerGradient, 'color-strip hue1': true}\"></div>\n        <div \n            class=\"aw-row m-b25\" \n        >\n            <div \n                class=\"col s12\"\n            >\n                <ng-container>\n                    <ng-container *ngIf=\"!!breadcrumbs\">\n                        <div class=\"aw-hide-on-med-and-down\">\n                            <ng-container *ngTemplateOutlet=\"breadcrumbs\"></ng-container>\n                        </div>\n                    </ng-container>\n                    <ng-container *ngIf=\"(!!mobileBreadcrumbs || !!breadcrumbs)\">\n                        <div class=\"aw-hide-on-large-only\">\n                            <ng-container *ngTemplateOutlet=\"mobileBreadcrumbs || breadcrumbs\"></ng-container>\n                        </div>\n                    </ng-container>\n                    <div *ngIf=\"hasStepper\" class=\"type3-stepper\">\n                        <div class=\"aw-container flex flex-row\">\n                            <div class=\"layout-stepper-item layout-stepper-item-left\">\n                                <ng-container *ngTemplateOutlet=\"stepperLeft || empty\"></ng-container>\n                            </div>\n                            <div class=\"layout-stepper-item\" *ngIf=\"!!stepperCenter\">\n                                <ng-container *ngTemplateOutlet=\"stepperCenter\"></ng-container>\n                            </div>\n                            <div class=\"layout-stepper-item layout-stepper-item-right\">\n                                <ng-container *ngTemplateOutlet=\"stepperRight || empty\"></ng-container>\n                            </div>\n                        </div>\n                    </div>\n                </ng-container>\n\n                <div class=\"layout-mt\">\n                    <ng-container>\n                        <h1 class=\"m-b3\" automation=\"pageHeader\">\n                            <ng-container *ngTemplateOutlet=\"title\"></ng-container>\n                        </h1>\n                    </ng-container>\n                    <div automation=\"pageContent\">\n                        <ng-container *ngTemplateOutlet=\"content\"></ng-container>  \n                    </div>\n                </div>\n            </div>\n        </div>\n        <ng-container *ngIf=\"!!anchoredBottomPanel\">\n            <aw-anchored-bottom-panel>\n                <ng-container *ngTemplateOutlet=\"anchoredBottomPanel\"></ng-container>\n            </aw-anchored-bottom-panel>\n        </ng-container>\n        <ng-container ngProjectAs=\"[aw-responsive-layout-footer]\">\n            <ng-container *ngTemplateOutlet=\"globalFooter\"></ng-container>\n        </ng-container>\n    </div>\n</aw-responsive-layout-base>\n\n<ng-template #empty><span></span></ng-template>"
            }]
    }], null, { fullWidth: [{
            type: Input
        }], mode: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }], fullscreenOnSmall: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], elementId: [{
            type: Input
        }], mobileBackgroundUrl: [{
            type: Input
        }], desktopBackgroundUrl: [{
            type: Input
        }], anchoredBottomPanel: [{
            type: Input
        }], title: [{
            type: Input
        }], content: [{
            type: Input
        }], breadcrumbs: [{
            type: Input
        }], mobileBreadcrumbs: [{
            type: Input
        }], globalFooter: [{
            type: Input
        }], stepperLeft: [{
            type: Input
        }], stepperCenter: [{
            type: Input
        }], stepperRight: [{
            type: Input
        }], stripBannerGradient: [{
            type: Input
        }], navigation: [{
            type: Input
        }], fixedHeight: [{
            type: Input
        }] }); })();

class AwLayoutContentDirective {
    constructor(templateRef, layoutService) {
        this.templateRef = templateRef;
        this.layoutService = layoutService;
    }
    set content(contentPart) {
        if (!this.layoutService) {
            return;
        }
        this._contentPart = contentPart;
        setTimeout(() => {
            this.layoutService.registerElement(contentPart, this.templateRef);
        });
    }
    ngOnDestroy() {
        if (!this.layoutService) {
            return;
        }
        if (this._contentPart) {
            setTimeout(() => {
                this.layoutService.registerElement(this._contentPart, undefined);
            });
        }
    }
}
AwLayoutContentDirective.ɵfac = function AwLayoutContentDirective_Factory(t) { return new (t || AwLayoutContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(AwLayoutProvider, 8)); };
AwLayoutContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwLayoutContentDirective, selectors: [["", "awLayoutContent", ""]], inputs: { content: ["awLayoutContent", "content"] } });
AwLayoutContentDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: AwLayoutProvider, decorators: [{ type: Optional }] }
];
AwLayoutContentDirective.propDecorators = {
    content: [{ type: Input, args: ['awLayoutContent',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwLayoutContentDirective, [{
        type: Directive,
        args: [{ selector: '[awLayoutContent]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: AwLayoutProvider, decorators: [{
                type: Optional
            }] }]; }, { content: [{
            type: Input,
            args: ['awLayoutContent']
        }] }); })();

class AwResponsiveLayoutType2Component extends AwComponent {
    getBCClasses() {
        switch (this.mode) {
            case 'B':
                return 'col s12 offset-l1 l10 offset-xl2 xl8';
            case 'C':
                return 'col s12 offset-l2 l8 offset-xl3 xl6';
            default:
                return '';
        }
    }
}
AwResponsiveLayoutType2Component.ɵfac = function AwResponsiveLayoutType2Component_Factory(t) { return ɵAwResponsiveLayoutType2Component_BaseFactory(t || AwResponsiveLayoutType2Component); };
AwResponsiveLayoutType2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwResponsiveLayoutType2Component, selectors: [["aw-responsive-layout-type2"]], inputs: { fullWidth: "fullWidth", fullscreen: "fullscreen", fullscreenOnSmall: "fullscreenOnSmall", styleClasses: "styleClasses", elementId: "elementId", mobileBackgroundUrl: "mobileBackgroundUrl", desktopBackgroundUrl: "desktopBackgroundUrl", mode: "mode", title: "title", subtitle: "subtitle", footer: "footer", content: "content", titleImage: "titleImage", topPanel: "topPanel", globalFooter: "globalFooter", navigation: "navigation", fixedHeight: "fixedHeight" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 16, vars: 22, consts: [[4, "ngIf"], [1, "ml-full-x", 3, "styleClasses", "elementId", "mobileBackgroundUrl", "desktopBackgroundUrl", "automationValue", "justifyCenter", "fixedHeight"], ["ngProjectAs", "[aw-responsive-layout-content]", 5, ["", "aw-responsive-layout-content", ""]], [1, "aw-row"], [1, "col", "s12", "offset-xl2", "xl8"], [1, "layout-content"], ["automation", "topPanel", 4, "ngIf"], [3, "ngSwitch"], ["class", "aw-form-indent m-b25 flex-regular", 4, "ngSwitchCase"], ["class", "aw-row m-b25 flex-regular", 4, "ngSwitchDefault"], ["ngProjectAs", "[aw-responsive-layout-footer]", 5, ["", "aw-responsive-layout-footer", ""]], [4, "ngTemplateOutlet"], ["template", ""], [1, "ml-full-x", "ml-full-top"], ["automation", "topPanel"], [1, "aw-form-indent", "m-b25", "flex-regular"], [1, "aw-row", "m-b25", "flex-regular"], [3, "ngClass"], [1, "aw-form-indent-small-24"], [1, "aw-divider"], ["automation", "pageFooter", 1, "aw-form-indent", "py15", "center-align"], ["class", "pt3 center-align", 4, "ngIf"], ["automation", "pageContent"], [1, "pt3", "center-align"], ["automation", "pageImage", "class", "m-b15", 4, "ngIf"], ["automation", "pageHeader", "class", "h3", 3, "ngClass", 4, "ngIf"], ["automation", "pageSubheader", "class", "neutral7-text m-b3", 4, "ngIf"], ["automation", "pageImage", 1, "m-b15"], ["automation", "pageHeader", 1, "h3", 3, "ngClass"], ["automation", "pageSubheader", 1, "neutral7-text", "m-b3"]], template: function AwResponsiveLayoutType2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AwResponsiveLayoutType2Component_ng_container_0_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(1, "aw-responsive-layout-base", 1);
        ɵngcc0.ɵɵelementContainerStart(2, 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, AwResponsiveLayoutType2Component_div_6_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵelementContainerStart(7, 7);
        ɵngcc0.ɵɵtemplate(8, AwResponsiveLayoutType2Component_div_8_Template, 2, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(9, AwResponsiveLayoutType2Component_div_9_Template, 2, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(10, AwResponsiveLayoutType2Component_div_10_Template, 4, 2, "div", 9);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(11, AwResponsiveLayoutType2Component_ng_container_11_Template, 4, 1, "ng-container", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(12, 10);
        ɵngcc0.ɵɵtemplate(13, AwResponsiveLayoutType2Component_ng_container_13_Template, 1, 0, "ng-container", 11);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, AwResponsiveLayoutType2Component_ng_template_14_Template, 3, 8, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.navigation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hasFooter", ctx.globalFooter);
        ɵngcc0.ɵɵproperty("styleClasses", ctx.styleClasses)("elementId", ctx.elementId)("mobileBackgroundUrl", ctx.mobileBackgroundUrl)("desktopBackgroundUrl", ctx.desktopBackgroundUrl)("automationValue", ctx.automationValue)("justifyCenter", ctx.mode == "D")("fixedHeight", ctx.fixedHeight);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("min-height", ctx.mode == "D")("m-t4", ctx.mode != "D")("m-y4", ctx.mode == "D");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.topPanel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.mode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "A");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "D");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.footer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.globalFooter);
    } }, directives: [ɵngcc1.NgIf, AwResponsiveLayoutBaseComponent, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgClass], encapsulation: 2 });
AwResponsiveLayoutType2Component.propDecorators = {
    fullWidth: [{ type: Input }],
    fullscreen: [{ type: Input }],
    fullscreenOnSmall: [{ type: Input }],
    styleClasses: [{ type: Input }],
    elementId: [{ type: Input }],
    mobileBackgroundUrl: [{ type: Input }],
    desktopBackgroundUrl: [{ type: Input }],
    mode: [{ type: Input }],
    title: [{ type: Input }],
    subtitle: [{ type: Input }],
    footer: [{ type: Input }],
    content: [{ type: Input }],
    titleImage: [{ type: Input }],
    topPanel: [{ type: Input }],
    globalFooter: [{ type: Input }],
    navigation: [{ type: Input }],
    fixedHeight: [{ type: Input }]
};
const ɵAwResponsiveLayoutType2Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwResponsiveLayoutType2Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwResponsiveLayoutType2Component, [{
        type: Component,
        args: [{
                selector: 'aw-responsive-layout-type2',
                template: "\n<ng-container *ngIf=\"navigation\">\n    <div class=\"ml-full-x ml-full-top\"><ng-container *ngTemplateOutlet=\"navigation\"></ng-container></div>\n</ng-container>\n<aw-responsive-layout-base\n    [styleClasses]=\"styleClasses\"\n    [elementId]=\"elementId\"\n    [mobileBackgroundUrl]=\"mobileBackgroundUrl\"\n    [desktopBackgroundUrl]=\"desktopBackgroundUrl\"\n    [automationValue]=\"automationValue\"\n    [justifyCenter]=\"mode=='D'\"\n    [class.hasFooter]=\"globalFooter\" \n    class=\"ml-full-x\"\n    [fixedHeight]=\"fixedHeight\"\n>\n    <ng-container ngProjectAs=\"[aw-responsive-layout-content]\">\n        <div class=\"aw-row\">\n            <div class=\"col s12 offset-xl2 xl8\">\n                <div \n                    class=\"layout-content\"\n                    [class.min-height]=\"mode=='D'\"\n                    [class.m-t4]=\"mode!='D'\"\n                    [class.m-y4]=\"mode=='D'\"\n                >\n                    <div automation=\"topPanel\" *ngIf=\"topPanel\">\n                        <ng-container *ngTemplateOutlet=\"topPanel\"></ng-container>\n                    </div>\n                    <ng-container [ngSwitch]=\"mode\">\n                        <div class=\"aw-form-indent m-b25 flex-regular\" *ngSwitchCase=\"'A'\">\n                            <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n                        </div>\n                        <div class=\"aw-form-indent m-b25 flex-regular\" *ngSwitchCase=\"'D'\">\n                            <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n                        </div>\n                        <div class=\"aw-row m-b25 flex-regular\" *ngSwitchDefault>\n                            <div [ngClass]=\"getBCClasses()\">\n                                <div class=\"aw-form-indent-small-24\">\n                                    <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n                                </div>\n                            </div>\n                        </div>\n                    </ng-container>    \n                    <ng-container *ngIf=\"!!footer\">              \n                        <div class=\"aw-divider\"></div>\n                        <div automation=\"pageFooter\" class=\"aw-form-indent py15 center-align\">\n                            <ng-container *ngTemplateOutlet=\"footer\"></ng-container>\n                        </div>\n                    </ng-container>\n                </div>\n            </div>\n        </div>\n        <ng-container ngProjectAs=\"[aw-responsive-layout-footer]\">\n            <ng-container *ngTemplateOutlet=\"globalFooter\"></ng-container>\n        </ng-container>\n    </ng-container>\n</aw-responsive-layout-base>\n\n<ng-template #template>\n    <div class=\"pt3 center-align\" *ngIf=\"!!titleImage||!!subtitle||!!title\">\n        <div \n            automation=\"pageImage\" \n            class=\"m-b15\" \n            *ngIf=\"!!titleImage\">\n            <ng-container  *ngTemplateOutlet=\"titleImage\"></ng-container>\n        </div>\n        <h1 automation=\"pageHeader\" class=\"h3\" [ngClass]=\"{'m-b3':!subtitle}\" \n            *ngIf=\"!!title\">\n                <ng-container *ngTemplateOutlet=\"title\"></ng-container>\n        </h1>\n        <p automation=\"pageSubheader\" class=\"neutral7-text m-b3\" *ngIf=\"!!subtitle && !!title\">\n            <ng-container *ngTemplateOutlet=\"subtitle\"></ng-container>\n        </p>\n    </div>\n    <div \n        automation=\"pageContent\"\n        [class.m-b0]=\"!!footer\" \n        [class.pt15]=\"!titleImage&&!subtitle&&!title\"\n        [class.m-b0]=\"!footer\"\n    >\n        <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n    </div>\n</ng-template>\n"
            }]
    }], null, { fullWidth: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }], fullscreenOnSmall: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], elementId: [{
            type: Input
        }], mobileBackgroundUrl: [{
            type: Input
        }], desktopBackgroundUrl: [{
            type: Input
        }], mode: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], footer: [{
            type: Input
        }], content: [{
            type: Input
        }], titleImage: [{
            type: Input
        }], topPanel: [{
            type: Input
        }], globalFooter: [{
            type: Input
        }], navigation: [{
            type: Input
        }], fixedHeight: [{
            type: Input
        }] }); })();

class AwResponsiveLayoutModule {
}
AwResponsiveLayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwResponsiveLayoutModule });
AwResponsiveLayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwResponsiveLayoutModule_Factory(t) { return new (t || AwResponsiveLayoutModule)(); }, providers: [
        DualContentService
    ], imports: [[
            CommonModule,
            AwButtonModule,
            AwAnchoredBottomPanelModule,
            AwMultiColumnContentModule,
            AwStepperProgressModule,
            AwProgressBarModule,
            AwMobileLayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwResponsiveLayoutModule, { declarations: function () { return [AwResponsiveLayoutComponent, AwResponsiveLayoutBaseComponent, AwResponsiveLayoutType1Component, AwResponsiveLayoutType2Component, AwResponsiveLayoutType3Component, AwLayoutContentDirective]; }, imports: function () { return [CommonModule,
        AwButtonModule,
        AwAnchoredBottomPanelModule,
        AwMultiColumnContentModule,
        AwStepperProgressModule,
        AwProgressBarModule,
        AwMobileLayoutModule]; }, exports: function () { return [AwResponsiveLayoutComponent, AwLayoutContentDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwResponsiveLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AwButtonModule,
                    AwAnchoredBottomPanelModule,
                    AwMultiColumnContentModule,
                    AwStepperProgressModule,
                    AwProgressBarModule,
                    AwMobileLayoutModule
                ],
                declarations: [
                    AwResponsiveLayoutComponent,
                    AwResponsiveLayoutBaseComponent,
                    AwResponsiveLayoutType1Component,
                    AwResponsiveLayoutType2Component,
                    AwResponsiveLayoutType3Component,
                    AwLayoutContentDirective
                ],
                exports: [
                    AwResponsiveLayoutComponent,
                    AwLayoutContentDirective
                ],
                providers: [
                    DualContentService
                ]
            }]
    }], null, null); })();

export { AwLayoutContentDirective, AwLayoutProvider, AwResponsiveLayoutBaseComponent, AwResponsiveLayoutComponent, AwResponsiveLayoutModule, AwResponsiveLayoutType1Component, AwResponsiveLayoutType2Component, AwResponsiveLayoutType3Component };

//# sourceMappingURL=aw-ads-components-aw-responsive-layout.js.map